// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  display: flex;
  min-height: 100vh;
}

.login-left {
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 2rem;
  background-color: #fafafa;
}

.login-logo {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 2rem;
}

.login-logo img {
  height: 40px;
}

.login-logo h2 {
  font-size: 24px;
  color: #000;
}

.login-form-container {
  width: 100%;
  max-width: 400px;
  padding-top: 2rem;
}

.login-form-container h1 {
  font-size: 32px;
  margin-bottom: 24px;
  position: relative;
}

.login-form-container h1::after {
  content: "";
  position: absolute;
  bottom: -8px;
  left: 0;
  width: 40px;
  height: 4px;
  background-color: #000;
  border-radius: 2px;
}

.form-group {
  margin-bottom: 0.75rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  color: #333;
  font-weight: 500;
}

.form-group input {
  width: 100%;
  padding: 0.8rem;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 1rem;
  background-color: white;
}

.form-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  margin-top: 0.25rem;
}

.remember-me {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #666;
  font-size: 0.9rem;
}

.forgot-password {
  color: #ffb800;
  text-decoration: none;
  font-weight: 500;
  font-size: 0.9rem;
}

.login-button {
  width: 100%;
  padding: 0.8rem;
  background-color: #000;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  cursor: pointer;
  margin-bottom: 1rem;
}

.signup-prompt {
  text-align: right;
  color: #666;
  margin-bottom: 1.5rem;
  margin-top: -0.5rem;
}

.signup-prompt a {
  color: #ffb800;
  text-decoration: none;
  font-weight: 500;
}

.divider {
  text-align: center;
  position: relative;
  margin: 1rem 0;
}

.divider::before,
.divider::after {
  content: "";
  position: absolute;
  top: 50%;
  width: 45%;
  height: 1px;
  background-color: #ddd;
}

.divider::before {
  left: 0;
}

.divider::after {
  right: 0;
}

.divider span {
  background-color: #fafafa;
  padding: 0 1rem;
  color: #666;
}

.social-logins {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.social-logins button {
  width: 100%;
  padding: 0.8rem;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  cursor: pointer;
  font-size: 0.9rem;
  color: #333;
  transition: background-color 0.2s, border-color 0.2s;
}

.social-logins button:hover {
  background-color: #f5f5f5;
  border-color: #ccc;
}

.social-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.google-login {
  border-color: #dadce0 !important;
}

.apple-login .social-icon {
  color: #000;
}

.facebook-login {
  /* border-color: #1877f2 !important; */
}

.facebook-login .social-icon {
  width: 24px;
  height: 24px;
  border-radius: 8px;
}

.login-right {
  width: 50%;
  background-color: #000;
  display: flex;
  align-items: center;
  padding: 4rem;
  padding-top: 8rem;
  position: relative;
}

.background-image {
  position: absolute;
  top: 0;
  right: 0;
  width: 300px; /* Adjust size as needed */
  height: auto;
  opacity: 0.9;
}

.promo-content {
  position: relative;
  z-index: 2;
  max-width: 600px;
}

.promo-text {
  margin-bottom: 2rem;
}

.promo-text h2 {
  font-size: 4rem;
  line-height: 1.1;
  color: white;
  margin: 0;
}

.promo-text h2 span {
  color: #ffb800;
}

.promo-content p {
  font-size: 1.1rem;
  line-height: 1.6;
  color: #fff;
  opacity: 0.8;
  max-width: 500px;
}

@media (max-width: 768px) {
  .login-container {
    flex-direction: column;
  }

  .login-left {
    width: 100%;
    padding: 2rem;
  }

  .login-right {
    display: none;
  }
}

.forgot-description {
  color: #666;
  margin-bottom: 2rem;
  font-size: 0.95rem;
  line-height: 1.5;
}

.forgot-password-page .divider span {
  content: "Or Sign in with";
}

.error-message {
  color: #ff3333;
  background-color: #ffe6e6;
  padding: 0.75rem;
  border-radius: 8px;
  margin-bottom: 1rem;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Login.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,oDAAoD;AACtD;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,YAAY,EAAE,0BAA0B;EACxC,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":[".login-container {\n  display: flex;\n  min-height: 100vh;\n}\n\n.login-left {\n  width: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  padding: 2rem;\n  background-color: #fafafa;\n}\n\n.login-logo {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 2rem;\n}\n\n.login-logo img {\n  height: 40px;\n}\n\n.login-logo h2 {\n  font-size: 24px;\n  color: #000;\n}\n\n.login-form-container {\n  width: 100%;\n  max-width: 400px;\n  padding-top: 2rem;\n}\n\n.login-form-container h1 {\n  font-size: 32px;\n  margin-bottom: 24px;\n  position: relative;\n}\n\n.login-form-container h1::after {\n  content: \"\";\n  position: absolute;\n  bottom: -8px;\n  left: 0;\n  width: 40px;\n  height: 4px;\n  background-color: #000;\n  border-radius: 2px;\n}\n\n.form-group {\n  margin-bottom: 0.75rem;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 0.5rem;\n  color: #333;\n  font-weight: 500;\n}\n\n.form-group input {\n  width: 100%;\n  padding: 0.8rem;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  font-size: 1rem;\n  background-color: white;\n}\n\n.form-options {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n  margin-top: 0.25rem;\n}\n\n.remember-me {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: #666;\n  font-size: 0.9rem;\n}\n\n.forgot-password {\n  color: #ffb800;\n  text-decoration: none;\n  font-weight: 500;\n  font-size: 0.9rem;\n}\n\n.login-button {\n  width: 100%;\n  padding: 0.8rem;\n  background-color: #000;\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  font-size: 1rem;\n  cursor: pointer;\n  margin-bottom: 1rem;\n}\n\n.signup-prompt {\n  text-align: right;\n  color: #666;\n  margin-bottom: 1.5rem;\n  margin-top: -0.5rem;\n}\n\n.signup-prompt a {\n  color: #ffb800;\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.divider {\n  text-align: center;\n  position: relative;\n  margin: 1rem 0;\n}\n\n.divider::before,\n.divider::after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  width: 45%;\n  height: 1px;\n  background-color: #ddd;\n}\n\n.divider::before {\n  left: 0;\n}\n\n.divider::after {\n  right: 0;\n}\n\n.divider span {\n  background-color: #fafafa;\n  padding: 0 1rem;\n  color: #666;\n}\n\n.social-logins {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.social-logins button {\n  width: 100%;\n  padding: 0.8rem;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  background-color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.75rem;\n  cursor: pointer;\n  font-size: 0.9rem;\n  color: #333;\n  transition: background-color 0.2s, border-color 0.2s;\n}\n\n.social-logins button:hover {\n  background-color: #f5f5f5;\n  border-color: #ccc;\n}\n\n.social-icon {\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n}\n\n.google-login {\n  border-color: #dadce0 !important;\n}\n\n.apple-login .social-icon {\n  color: #000;\n}\n\n.facebook-login {\n  /* border-color: #1877f2 !important; */\n}\n\n.facebook-login .social-icon {\n  width: 24px;\n  height: 24px;\n  border-radius: 8px;\n}\n\n.login-right {\n  width: 50%;\n  background-color: #000;\n  display: flex;\n  align-items: center;\n  padding: 4rem;\n  padding-top: 8rem;\n  position: relative;\n}\n\n.background-image {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 300px; /* Adjust size as needed */\n  height: auto;\n  opacity: 0.9;\n}\n\n.promo-content {\n  position: relative;\n  z-index: 2;\n  max-width: 600px;\n}\n\n.promo-text {\n  margin-bottom: 2rem;\n}\n\n.promo-text h2 {\n  font-size: 4rem;\n  line-height: 1.1;\n  color: white;\n  margin: 0;\n}\n\n.promo-text h2 span {\n  color: #ffb800;\n}\n\n.promo-content p {\n  font-size: 1.1rem;\n  line-height: 1.6;\n  color: #fff;\n  opacity: 0.8;\n  max-width: 500px;\n}\n\n@media (max-width: 768px) {\n  .login-container {\n    flex-direction: column;\n  }\n\n  .login-left {\n    width: 100%;\n    padding: 2rem;\n  }\n\n  .login-right {\n    display: none;\n  }\n}\n\n.forgot-description {\n  color: #666;\n  margin-bottom: 2rem;\n  font-size: 0.95rem;\n  line-height: 1.5;\n}\n\n.forgot-password-page .divider span {\n  content: \"Or Sign in with\";\n}\n\n.error-message {\n  color: #ff3333;\n  background-color: #ffe6e6;\n  padding: 0.75rem;\n  border-radius: 8px;\n  margin-bottom: 1rem;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
